import { AnalyticsID } from 'lib/analytics/constants';
import type { PolarAnalytics } from 'lib/analytics/polar';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { useAnalyticsDelegatorStore } from './useAnalyticsStore';
import { useIsCookieConsented } from './useCookiebotConsent';

export const usePolarLandingPageView = () => {
  const router = useRouter();
  const consented = useIsCookieConsented();
  const analyticsDelegator = useAnalyticsDelegatorStore(
    (s) => s.analyticsDelegator,
  );
  const sinksRegistered = useAnalyticsDelegatorStore((s) => s.sinksRegistered);
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current || !sinksRegistered || !consented) return;

    const sink = analyticsDelegator.getSink<PolarAnalytics>(
      AnalyticsID.PolarSdk,
    );

    if (!sink) return;

    sentRef.current = true;
    sink.events.pageView({ url: router.asPath });
  }, [analyticsDelegator, sinksRegistered, consented, router.asPath]);
};
